import script from "./ContextMenu.vue?vue&type=script&lang=ts"
export * from "./ContextMenu.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__